import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-navy-900 py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-249" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-250" data-mp="3fxb22ggddmb4">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-251" data-mp="3azjcht376ca3">
          Testimonios de docentes que ya tienen su Megapack
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-252" data-mp="32063f1izjppw">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-silver-400/25 bg-navy-800 p-6 shadow-sm shadow-black/20" data-id="element-253" data-mp="2x1utyrwlrh87" data-mpi={index}>
              <div className="flex text-silver-200" aria-label="5 de 5 estrellas" data-id="element-254" data-mp="h4n6gjawodem">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-255" data-mp="78aa1dnz7lg6" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-silver-100" data-id="element-256" data-mp="c7mz852bl4lx">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-silver-400/20 pt-4" data-id="element-257" data-mp="zwy2bt757b38">
                <span className="metal-silver flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-sm font-extrabold text-navy-950" data-id="element-258" data-mp="14u7qz6mpjiq0">
                  {initials}
                </span>
                <span data-id="element-259" data-mp="v4emepkzg3v9">
                  <b className="block text-sm text-white" data-id="element-260" data-mp="v3mqterdy64z">{name}</b>
                  <small className="text-xs text-silver-300" data-id="element-261" data-mp="1iuiga58dcp92">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}